import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-metrics.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
export type ImageTypes = 'image' | 'video-thumbnail' | 'profile';
export type VerticalAlign = 'top' | 'center' | 'bottom';
export type TextVariant = 'default' | 'light' | 'dark';
export type MediaPositions = 'top' | 'left' | 'right';
// import { SlotController } from '../../controllers/slot-controller';
// import { SlotsController } from '../../controllers/slots-controller';

/**
 * The IDB Image Card component.
 * @element idb-metrics
 * @extends OutlineElement
 */
@customElement('idb-metrics')
export class IdbMetrics extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="container">
        ${Array.from(this.children).map((current: any) => current)}
      </div>
    `;
  }
}
